export const enum QuestionTypeEnum {
  TEXT = "text",
  TEXT_AREA = "textarea",
  NUMBER = "number",
  RADIO_BUTTONS = "radio",
  MULTI_SELECT = "multiselect",
  DATE = "date",
  SINGLE_IMAGE = "single_image",
  MULTIPLE_IMAGES = "multiple_images",
  SINGLE_FILE = "single_file",
  MULTIPLE_FILES = "multiple_files",
  ELECTRONIC_SIGNATURE = "electronic_signature",
}

export const QuestionTypeDescriptionMapping = {
  [QuestionTypeEnum.TEXT]: {
    short: "Text input",
    decription: "Single line text input",
  },
  [QuestionTypeEnum.TEXT_AREA]: {
    short: "Text area",
    decription: "Multiple line text input",
  },
  [QuestionTypeEnum.NUMBER]: {
    short: "Number input",
    decription: "Numeric input with optional min and max validation values",
  },
  [QuestionTypeEnum.RADIO_BUTTONS]: {
    short: "Single select",
    decription: "Single select input shown as radio buttons",
  },
  [QuestionTypeEnum.MULTI_SELECT]: {
    short: "Multi select",
    decription: "Multi select input shown as checkboxes",
  },
  [QuestionTypeEnum.DATE]: { short: "Date", decription: "Date input" },
  [QuestionTypeEnum.SINGLE_IMAGE]: {
    short: "Single image",
    decription: "Image upload field allowing for common image files types.",
  },
  [QuestionTypeEnum.MULTIPLE_IMAGES]: {
    short: "Multiple images",
    decription:
      "Multiple image upload field allowing for common image files types.",
  },
  [QuestionTypeEnum.SINGLE_FILE]: {
    short: "Single file",
    decription: "Single file input",
  },
  [QuestionTypeEnum.MULTIPLE_FILES]: {
    short: "Multiple files",
    decription: "Multiple files input",
  },
  [QuestionTypeEnum.ELECTRONIC_SIGNATURE]: {
    short: "Electronic signature",
    decription:
      "Allow user to sign on a on the device using the mouse, touch or pen.",
  },
};

export const CHOICE_TYPES: QuestionTypeEnum[] = [
  QuestionTypeEnum.RADIO_BUTTONS,
  QuestionTypeEnum.MULTI_SELECT,
];

export const INPUT_TYPES: QuestionTypeEnum[] = [
  QuestionTypeEnum.TEXT,
  QuestionTypeEnum.TEXT_AREA,
  QuestionTypeEnum.NUMBER,
];

export const FILE_TYPES: QuestionTypeEnum[] = [
  QuestionTypeEnum.SINGLE_IMAGE,
  QuestionTypeEnum.MULTIPLE_IMAGES,
  QuestionTypeEnum.SINGLE_FILE,
  QuestionTypeEnum.MULTIPLE_FILES,
];

export const IMAGE_TYPES: QuestionTypeEnum[] = [
  QuestionTypeEnum.SINGLE_IMAGE,
  QuestionTypeEnum.MULTIPLE_IMAGES,
];

export const QuestionTypeEditListing = [
  {
    section: "Inputs",
    types: INPUT_TYPES,
  },
  {
    section: "Selection",
    types: CHOICE_TYPES,
  },
  { section: "Date", types: [QuestionTypeEnum.DATE] },
  {
    section: "File upload",
    types: FILE_TYPES,
  },
  {
    section: "Signatures",
    types: [QuestionTypeEnum.ELECTRONIC_SIGNATURE],
  },
];
